<template>
  <el-container class="app-container">
    <el-aside width="200px" v-if="isLoggedIn">
      <div class="logo">管理后台</div>
      <el-menu :default-active="activeMenu" class="el-menu-vertical-demo" @select="handleMenuSelect">
        <el-submenu index="system">
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span>系统管理</span>
          </template>
          <el-menu-item index="admin-user">管理员管理</el-menu-item>
          <el-menu-item index="admin-role">角色管理</el-menu-item>
          <el-menu-item index="admin-permission">权限管理</el-menu-item>
        </el-submenu>
        <el-submenu index="user">
          <template slot="title">
            <i class="el-icon-user"></i>
            <span>用户管理</span>
          </template>
          <el-menu-item index="user-list">用户列表</el-menu-item>
          <el-menu-item index="user-message">用户消息</el-menu-item>
          <el-menu-item index="vip-order">VIP订单</el-menu-item>
        </el-submenu>
        <el-submenu index="content">
          <template slot="title">
            <i class="el-icon-document"></i>
            <span>内容管理</span>
          </template>
          <el-menu-item index="record">心情记录</el-menu-item>
          <el-menu-item index="relation">关系管理</el-menu-item>
          <el-menu-item index="square">广场内容</el-menu-item>
          <el-menu-item index="love-pk">PK管理</el-menu-item>
          <el-menu-item index="love-pk-theme">PK主题</el-menu-item>
          <el-menu-item index="feedback">意见反馈</el-menu-item>
          <el-menu-item index="barrage">弹幕管理</el-menu-item>
          <el-menu-item index="gift">礼物管理</el-menu-item>
        </el-submenu>
        <el-submenu index="stats">
          <template slot="title">
            <i class="el-icon-data-analysis"></i>
            <span>数据统计</span>
          </template>
          <el-menu-item index="emotion-stats">情感统计</el-menu-item>
          <el-menu-item index="user-stats">用户统计</el-menu-item>
          <el-menu-item index="content-stats">内容统计</el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header v-if="isLoggedIn">
        <div class="header-right">
          <span>{{ adminInfo.nickname }}</span>
          <el-button type="primary" plain @click="handleLogout">登出</el-button>
        </div>
      </el-header>
      <el-main>
        <router-view v-if="isLoggedIn" />
        <login v-else />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import login from './components/Login.vue'

export default {
  name: 'App',
  components: {
    login
  },
  data() {
    return {
      isLoggedIn: false,
      adminInfo: {},
      activeMenu: ''
    }
  },
  mounted() {
    this.checkLoginStatus()
  },
  methods: {
    // 检查登录状态
    checkLoginStatus() {
      const token = localStorage.getItem('adminToken')
      if (token) {
        this.isLoggedIn = true
        // 获取管理员信息
        this.fetchAdminInfo()
      }
    },

    // 获取管理员信息
    fetchAdminInfo() {
      const token = localStorage.getItem('adminToken')
      fetch('/api/admin/login/info', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
        .then(response => response.json())
        .then(data => {
          if (data.code === 0) {
            this.adminInfo = data.data
          } else {
            localStorage.removeItem('adminToken')
            this.isLoggedIn = false
          }
        })
        .catch(() => {
          localStorage.removeItem('adminToken')
          this.isLoggedIn = false
        })
    },

    // 处理菜单选择
    handleMenuSelect(key) {
      this.activeMenu = key
      // 根据key跳转到相应路由
      const routeMap = {
        'admin-user': '/admin/user',
        'admin-role': '/admin/role',
        'admin-permission': '/admin/permission',
        'user-list': '/user/list',
        'user-message': '/user/message',
        'vip-order': '/user/vip-order',
        'record': '/content/record',
        'relation': '/content/relation',
        'square': '/content/square',
        'love-pk': '/content/love-pk',
        'love-pk-theme': '/content/love-pk-theme',
        'feedback': '/content/feedback',
        'barrage': '/content/barrage',
        'gift': '/content/gift',
        'emotion-stats': '/stats/emotion',
        'user-stats': '/stats/user',
        'content-stats': '/stats/content'
      }
      if (routeMap[key]) {
        this.$router.push(routeMap[key])
      }
    },

    // 处理登出
    handleLogout() {
      const token = localStorage.getItem('adminToken')
      fetch('/api/admin/login/logout', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
        .then(() => {
          localStorage.removeItem('adminToken')
          this.isLoggedIn = false
          this.adminInfo = {}
          this.$router.push('/')
          this.$message.success('登出成功')
        })
        .catch(() => {
          this.$message.error('登出失败')
        })
    }
  }
}
</script>

<style>
/* 全局重置：浏览器默认 body 有 8px margin，会让 100vh/100% 布局整页溢出 16px，出现多余的窗口滚动条 */
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
}

/* 统一盒模型：避免元素 width + padding/border 叠加撑破容器（如 200px 菜单 + 1px 边框撑出侧边栏横向滚动条） */
* {
  box-sizing: border-box;
}

.app-container {
  height: 100%;
  display: flex;
  overflow: hidden;
}

.app-container > .el-container {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

/* 用 .app-container 提高优先级，覆盖 Element UI 自带的 .el-aside { overflow: auto }（该规则后加载会覆盖同优先级样式） */
.app-container .el-aside {
  background-color: #fff;
  color: #303133;
  border-right: 1px solid #e4e7ed;
  /* 菜单不需要横向滚动；纵向只在菜单超高时在侧边栏内部滚动 */
  overflow-x: hidden;
  overflow-y: auto;
}

.logo {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  line-height: 60px;
  background-color: #f5f7fa;
  color: #303133;
  border-bottom: 1px solid #e4e7ed;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 100%;
  min-height: 400px;
  background-color: #fff;
}

.el-menu {
  background-color: #fff !important;
}

.el-menu-item {
  color: #303133 !important;
}

.el-menu-item:hover,
.el-menu-item.is-active {
  background-color: #ecf5ff !important;
  color: #409eff !important;
}

.el-submenu__title {
  color: #303133 !important;
}

.el-submenu__title:hover {
  background-color: #ecf5ff !important;
  color: #409eff !important;
}

.el-header {
  background-color: #fff;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 20px;
  height: 60px;
  line-height: 60px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.el-main {
  padding: 20px;
  min-width: 0;
  overflow-y: auto;
}

/* 分页与上方表格/内容保持统一间距（所有列表页生效；限定在主内容区，避免影响弹窗） */
.el-main .el-pagination {
  margin-top: 20px;
}
</style>